// extracted by mini-css-extract-plugin
export default {"container":"TrendAlertItems_container__SHGgh","icons":"TrendAlertItems_icons__jIeOl","disabled":"TrendAlertItems_disabled__MueOI","loader":"TrendAlertItems_loader__-PhdY"};